import RegistrationStart from "../registration/RegistrationStart";

import {
  Box,
  Container,
  Typography,
  Link,
  Alert
} from '@mui/material';
import { useEffect, useState } from 'react';
import { APIHOST } from '../../common';
import UserAvatarMenu from '../../components/auth/UserAvatarMenu';
import { useAuth } from '../../components/auth/AuthContext';
import HotelAdminPage from '../../hotel-admin/HotelAdminPage';

export default function CityWideHousingSolutions() {
  const { showAuthDialog, currentUser } = useAuth();
  const [alertContent, setAlertContent] = useState<string | null>(null);
  const [alertError, setAlertError] = useState<string | null>(null);
  useEffect(() => {
    const fetchContent = async () => {
      try {
        setAlertError(null);
        const response = await fetch(`${APIHOST}/api/contents?filters[key][$eq]=home-page`);
        if (!response.ok) throw new Error('Failed to fetch alert content');
        const data = await response.json();
        setAlertContent(data?.data?.[0]?.content || null);
      } catch (err) {
        setAlertError('Could not load alert content.');
      }
    };
    fetchContent();
  }, []);

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <UserAvatarMenu />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '100vh',
            py: { xs: 8, md: 16 },
            px: { xs: 2, md: 8 },
            textAlign: { xs: 'center', sm: 'left' }
          }}
        >
          <Typography 
            variant="h2" 
            component="h1" 
            fontWeight="bold" 
            sx={{ 
              mb: 4, 
              fontSize: { xs: '2rem', md: '3rem', lg: '4rem' },
              lineHeight: 1.2 
            }}
          >
            CityWide Housing Solutions
          </Typography>
          {currentUser?.role?.name !== 'Hotel' && <Box>
            {alertError ? (
              <Alert severity="error" sx={{ mb: 4 }} icon={false}>{alertError}</Alert>
            ) : alertContent ? (
              <Alert severity="warning" sx={{ mb: 4, whiteSpace: 'pre-wrap' }} icon={false}>
                <span dangerouslySetInnerHTML={{ __html: alertContent }} />
              </Alert>
            ) : null}
          </Box>}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%', maxWidth: 'md' }}>
            {currentUser?.role?.name === 'Hotel' ? <HotelAdminPage /> : <RegistrationStart />}
          </Box>
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Don't have a passcode?{' '}
              <Link href="/faq" underline="hover" fontWeight="medium">
                Check our FAQ
              </Link>
              {' '}for help getting started.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}